module.exports = __webpack_public_path__ + "img/no_halving_chart.66cb172e.svg";